import { canv } from "@/canv/global.js";
import { wmBase } from "@/widgetMenu/wmBase";
import { WmFilterSubmenu } from "./wm_filter_submenu";

export class WmFilter extends wmBase {
    build() {
        return `
            <div class="wm_filter">
                <div class="wm_filter_info">
                    <p class="wm_filter_text">Фильтр</p>
                    <p class="wm_filter_objects_count">Объектов ${canv.canvasController.selected.length}</p>
                </div>
                <svg class="svg" width="10" height="10" viewBox="0 0 8 7" xmlns="http://www.w3.org/2000/svg"><path d="M3.646 5.354l-3-3 .708-.708L4 4.293l2.646-2.647.708.708-3 3L4 5.707l-.354-.353z" fill-rule="evenodd" fill-opacity="1" fill="#000" stroke="none"></path></svg>
            </div>
        `;
    }

    init() {
        const item = document.querySelector(".wm_filter");
        item?.removeEventListener("click", this.itemClick, false);
        item?.addEventListener("click", this.itemClick, false);
    }

    itemClick = () => {
        this.submenu.show();
    };

    submenu = new WmFilterSubmenu();
}
